<div id="catalog-list-item-{{ item.id }}">
  <a
    [routerLink]="'/catalog/item/' + item.hxid"
    [state]="{ ymGoalName: YmGoalCatalogItem.OpenFromCatalog }"
    class="card card-hoverable card-s card-border-2 full-width"
  >
    <div class="card-body grid grid-column grid-gutter-12">
      <div class="grid-item">
        <div class="typography typography-body grey-700">
          {{ item.hxid | typeNomenclature : item.isComplex }}&nbsp;<span
            class="tag"
            >{{ item.hxid }}</span
          >
        </div>
      </div>
      <div class="grid-item full-width">
        <div
          class="grid grid-gutter-12 grid-nowrap justify-content-between grid-xs-column"
        >
          <div
            class="grid-item grid-grow grid-10 grid-md-8 grid-sm-10 grid-xs-12"
          >
            <div class="typography typography-headline grey-900">
              {{ item.title }}
            </div>
          </div>
          <div class="grid-item hidden-xs">
            <div class="grid justify-content-end prices-gap">
              <span class="grid-item typography typography-headline gray-400" *ngIf="item.marketPrice">
                <s strikeColor="--primary-color">{{ item.marketPrice }}&nbsp;{{ item.currency?.symbol }}</s>
              </span>
              <span
                class="grid-item typography typography-headline typography-bold grey-900 nowrap"
              >
                {{ item.price }}&nbsp;{{ item.currency?.symbol }}
              </span>
            </div>
          </div>

          <div class="hidden block-xs grid-item grid-xs-12 mt-32">
            <div class="grid align-items-center justify-content-between">
              <div class="grid-item">
                <span class="typography typography-headline gray-400" *ngIf="item.marketPrice">
                  <s strikeColor="--primary-color">{{ item.marketPrice }}&nbsp;{{ item.currency?.symbol }}</s>
                </span>
                <span
                  class="typography typography-headline typography-bold nowrap"
                >
                  {{ item.price }}&nbsp;{{ item.currency?.symbol }}
                </span>
              </div>
              <ng-container [ngTemplateOutlet]="preOrderButton"></ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-item" [class.hidden-xs]="!item.estimateInfo">
        <div class="divider"></div>
      </div>
      <div class="grid-item">
        <div class="grid grid-gutter-12">
          <div class="grid-item grid-grow">
            <div
              class="grid grid-gutter-12 grid-nowrap"
              *ngIf="item.estimateInfo"
            >
              <div class="grid-item">
                <div class="icon icon-20 icon-time green-basic"></div>
              </div>
              <div class="grid-item grid-10 grid-xs-11">
                <div
                  class="typography typography-body grey-700 typography-lines-2"
                >
                  {{ item.estimateInfo }}
                </div>
              </div>
            </div>
          </div>
          <div class="grid-item hidden-xs">
            <ng-container [ngTemplateOutlet]="preOrderButton"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </a>
</div>

<ng-template #preOrderButton>
  <button
    class="button button-secondary"
    [disabled]="(isLoading$ | async) || (isInCart$ | async)"
    appPreventDoubleclick
    (throttledClick)="tryAddItemToCart($event)"
    [throttleTime]="1000"
  >
    {{
      item.canPreOrder
        ? (isInCart$ | async)
          ? "В корзине"
          : "Заказать"
        : "Записаться"
    }}
  </button>
</ng-template>
